import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { GECKO_UTILS, GeckoBtn } from '../../';
import './dropdown.scss';
//https://reactstrap.github.io/components/button-dropdown/

class GeckoDropdown extends Component {
  state = {
    isOpen: false,
  };

  container = null;
  dropdown = null;

  toggle(event) {
    // Ignore toogle when item is clicked
    if (this.dropdown && event && this.dropdown.contains(event.target)) return;

    const table = document.querySelector('.gecko-table tbody');
    const isTableTarget =
      event &&
      event.target &&
      table &&
      table.contains(event.target) &&
      event.which === 1;
    // Stop event bubbling when table is clicked after popover closes
    if (this.state.isOpen && isTableTarget) event.stopPropagation();

    if (!this.state.isOpen) {
      this.setState({ isOpen: !this.state.isOpen }, () => this.move());
    } else {
      this.move(true).then(() => this.setState({ isOpen: !this.state.isOpen }));
    }
    this.props.onToggle();
  }

  move(reset) {
    return new Promise((resolve) => {
      if (reset && this.container && this.dropdown) {
        this.container.appendChild(this.dropdown);
        this.container = null;
        this.dropdown = null;
      } else {
        this.container = this.ref.containerRef.current;
        this.dropdown = this.container.querySelector('.dropdown-menu');

        if (document.querySelector('.gecko-modal-wrapper')) {
          document
            .querySelector('.gecko-modal-wrapper')
            .appendChild(this.dropdown);
        } else {
          document.body.appendChild(this.dropdown);
        }
      }
      return resolve(this.dropdown);
    });
  }

  renderMenuClasses() {
    let classes = [
      'gecko-dropdown-menu',
      `dropdown-menu-${this.props.align || 'left'}`,
    ];

    classes.push(
      GECKO_UTILS.prepareIndexClass('gecko-dropdown', this.props.index)
    );

    return GECKO_UTILS.classNames(classes);
  }

  isItemDisabled(item) {
    return item.disabled === true || (item.disabledWhen && item.disabledWhen());
  }

  renderItemClasses(item, index) {
    return GECKO_UTILS.classNames({
      heading: item.heading,
      'dropdown-item': true,
      disabled: this.isItemDisabled(item),
      [GECKO_UTILS.prepareNameClass(
        'gecko-dropdown-item',
        item.name
      )]: item.name,
      [GECKO_UTILS.prepareIndexClass('gecko-dropdown-item', index)]: true,
    });
  }

  itemHandler(item) {
    if (this.isItemDisabled(item)) {
      return;
    }
    if (item.handler) {
      item.handler.bind(this, this.props.bind)();
    }
    return this.toggle();
  }

  isHidden(item) {
    if (item.hideWhen) return item.hideWhen(this.props.bind);
    return false;
  }

  renderItem(item, i) {
    if (this.isHidden(item)) {
      return null;
    }
    return (
      <li
        className={this.renderItemClasses(item, i)}
        onClick={this.itemHandler.bind(this, item)}
        key={i}
      >
        {item.name}
      </li>
    );
  }

  render() {
    return (
      <Dropdown
        ref={(element) => (this.ref = element)}
        className="gecko-dropdown"
        isOpen={this.state.isOpen}
        toggle={this.toggle.bind(this)}
      >
        <DropdownToggle tag="span">
          <GeckoBtn
            className="gecko-dropdown-toggle"
            name={this.props.name}
            ariaLabel={this.props.ariaLabel}
            icon={this.props.icon}
            type={this.props.type}
            size={this.props.size}
            preset={this.props.preset}
            {...this.props.buttonConfig}
          />
        </DropdownToggle>

        <DropdownMenu
          tag="ul"
          className={this.renderMenuClasses()}
          right={this.props.align === 'right'}
        >
          {this.props.items.map((item, i) => this.renderItem(item, i))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

GeckoDropdown.defaultProps = {
  items: [],
  onToggle: () => {},
};

GeckoDropdown.propTypes = {
  items: PropTypes.array,
  onToggle: PropTypes.func,
};

export default GeckoDropdown;
